<!--<mat-label>Idioma</mat-label> {{POR O VALOR AQ INPUT}} -->
<mat-form-field appearance="fill">
    <mat-select data-test="select-idioma" required [value]="currentLanguageCompany" (selectionChange)="languageSelected($event.value)">
        <mat-option *ngFor="let language of languages" [value]="language" [attr.data-test]="'opcao-idioma-' + language.code">
            {{language.name}}
        </mat-option>
    </mat-select>
</mat-form-field>